import { faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addQuizSuggestion } from "../../../redux/actions/userActivity";
import { useParams } from "react-router-dom";
import "./index.css";

export default function ReportQuizModal({
  openReportModal,
  setOpenReportModal,
  quizDetails,
  currentQuizIndex,
}) {
  const quizSuggestionRef = useRef();
  const questionRef = useRef();
  const answerRef = useRef();
  const wrong1Ref = useRef();
  const wrong2Ref = useRef();
  const wrong3Ref = useRef();
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const { contentId } = useParams();

  function handleQuizReport() {
    if (quizSuggestionRef?.current?.value?.length > 0) {
      dispatch(
        addQuizSuggestion(
          user_id,
          contentId,
          quizDetails?.[0]?.id,
          quizSuggestionRef?.current?.value,
          questionRef?.current?.value,
          answerRef?.current?.value,
          wrong1Ref?.current?.value,
          wrong2Ref?.current?.value,
          wrong3Ref?.current?.value,
          (successObj) => {
            setOpenReportModal(false);
            console.log(successObj);
          },
        ),
      );
    } else {
      toast.warn("Quiz Report Reason is Required!");
    }
  }

  return (
    <Dialog
      open={openReportModal}
      onClose={() => setOpenReportModal(false)}
      as="div"
      className="fixed inset-0 top-5 z-10 flex h-[90%] w-full flex-col items-center justify-center overflow-y-auto md:-top-16 md:mt-28 md:justify-start"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="relative z-20 flex w-11/12 flex-col items-start justify-between rounded bg-white p-2 md:w-3/5 md:p-8 lg:w-2/5">
        <FontAwesomeIcon
          icon={faTimes}
          className="absolute top-3 right-3 cursor-pointer md:text-2xl"
          onClick={() => {
            setOpenReportModal(false);
          }}
        />
        <div className="flex items-center justify-center">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/Content_player/feedbackModal.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662628545349"
            }
            transformation={[
              {
                height: "110",
                width: "110",
              },
            ]}
            className="h-16 md:h-12"
          />
          <h2 className="mb-3 ml-4 text-center text-base font-bold md:text-xl">
            Report This Quiz Question
          </h2>
        </div>
        <p className="text-base font-semibold md:text-lg">
          What is wrong with this quiz Question?
          <span className="text-red-500">*</span>
        </p>
        <textarea
          ref={quizSuggestionRef}
          name=""
          id=""
          cols="50"
          rows="2"
          placeholder="Describe what is wrong with this quiz question"
          className="my-2 w-full resize-none rounded-lg border-2 border-gray-300"
          required
        ></textarea>
        <p className="mt-1 text-base font-semibold md:mt-3 md:text-lg">
          Suggest Replacement for this quiz question
        </p>
        <input
          ref={questionRef}
          type="text"
          name=""
          id=""
          className="my-2 w-full rounded border-2 border-gray-300"
          placeholder="Write your question here"
        />
        <div className="flex w-full items-center justify-between">
          <p className="mr-4 font-bold">A</p>
          <input
            ref={answerRef}
            type="text"
            name=""
            id=""
            className="my-2 w-full rounded border-2 border-[#2BBD13]"
            placeholder="Correct Answer"
          />
        </div>
        <div className="flex w-full items-center justify-between">
          <p className="mr-4 font-bold">B</p>
          <input
            ref={wrong1Ref}
            type="text"
            name=""
            id=""
            className="my-2 w-full rounded border-2 border-[#FF2633]"
            placeholder="Wrong Answer 1"
          />
        </div>
        <div className="flex w-full items-center justify-between">
          <p className="mr-4 font-bold">C</p>
          <input
            ref={wrong2Ref}
            type="text"
            name=""
            id=""
            className="my-2 w-full rounded border-2 border-[#FF2633]"
            placeholder="Wrong Answer 2"
          />
        </div>
        <div className="flex w-full items-center justify-between">
          <p className="mr-4 font-bold">D</p>
          <input
            ref={wrong3Ref}
            type="text"
            name=""
            id=""
            className="my-2 w-full rounded border-2 border-[#FF2633]"
            placeholder="Wrong Answer 3"
          />
        </div>
        <div className="flex items-center justify-center">
          <FontAwesomeIcon icon={faInfoCircle} className="text-[#086788]" />
          <small className="ml-2 text-supertiny font-bold">
            You will earn 10 coins for each suggestion that is accepted.
          </small>
        </div>
        {/* <small className='font-bold text-supertiny md:ml-12'>You will earn 10 coins for each suggestion that is accepted.</small> */}
        <button
          className="report-button mt-4 self-end rounded px-3 py-2 font-semibold md:mt-10"
          onClick={() => handleQuizReport()}
        >
          Report Suggestion
        </button>
      </div>
    </Dialog>
  );
}
